import AvatarWearableDropdown from './AvatarWearableDropdown.container'
export default AvatarWearableDropdown
